export enum boxListButtonClass {
  Create = "btn-sm btn-primary",
  Modify = "btn-sm btn-warning",
  Delete = "btn-sm btn-danger",
  Ban = "btn-sm btn-danger",
  Verify = "btn-sm btn-danger",
  Feature = "btn-sm btn-danger",
}

export enum boxListButtonSpanClass {
  Create = "lnr lnr-eye",
  Modify = "lnr lnr-pencil",
  Delete = "lnr lnr-trash",
  Ban = "",
  Verify = "",
  Feature = "",
}

export enum boxListButtonTooltipTarget {
  Create = "tooltip-view-",
  Modify = "tooltip-modify-",
  Delete = "tooltip-delete-",
  Ban = "tooltip-ban-",
  Verify = "tooltip-verify-",
  Feature = "tooltip-feature-",
}

export enum boxListButtonTooltipText {
  Create = "View",
  Modify = "Modify",
  Delete = "Delete",
  Ban = "Ban",
  Verify = "Change Verified Status",
  Feature = "Feature",
}
